import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './banner-content.html';
import { MySiteRestService } from '@nuskin/my-site-api';
import { nuskin } from '@nuskin/ns-util';
import { MySiteApp } from '../../my-site-app'
/**
 * @customElement
 * @polymer
 */
export class BannerContent extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);
    
        this.nsSearchTranslations = {
            desktopPlaceholder: 'Search for a product',
            mobilePlaceholder: 'Search for a product',
            noResults: this.content.yourProductsFormSearchNoResults
        }

        // pass save method to form wrapper
        this.parentNode.saveForm = this.save();

        this.noBannerOption = {
            titleText: this.content.bannerFormNoBanner,
            imageUrls: {
                mobile : '//via.placeholder.com/720x250?text='+this.content.bannerFormNoBanner.replace(/s+/g,'+'),
                desktop : '//via.placeholder.com/720x250?text='+this.content.bannerFormNoBanner.replace(/s+/g,'+'),
                tabet : '//via.placeholder.com/720x250?text='+this.content.bannerFormNoBanner.replace(/s+/g,'+')
            }
        }
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'banner-content';
    }

    static get properties() {
        return {
            // Phase 2 stuff

            // bannerLinkedProduct: {
            //   type: Object,
            //   observer: '_handleBannerLinkedProduct'
            // }
        };
    }

    connectedCallback() {
        super.connectedCallback();
        this.mySite = document.querySelector(MySiteApp.is);
        this.mySite.addEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
        this.$.bannerSelector.addEventListener('nsDropdownSelect', this._handleBannerSelect.bind(this));
    
        // Phase 2 stuff
    
        // this.$.productSearch.addEventListener('on-ns-searchbar-predictive-search-result', this._handlePredictiveSearch.bind(this));
        // this.$.linkBannerToProduct.addEventListener('iron-change', this._handleLinkBannerToProductChange.bind(this));
        // this.$.linkBannerToUrl.addEventListener('iron-change', this._handleLinkBannerToUrlChange.bind(this));

    // this.overwriteParepRadioButtonStyles();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.mySite.removeEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
        this.$.bannerSelector.removeEventListener('nsDropdownSelect', this._handleBannerSelect.bind(this));
    
        // Phase 2 stuff

    // this.$.removeEventListener.removeEventListener('on-ns-searchbar-predictive-search-result', this._handlePredictiveSearch.bind(this));
    // this.$.linkBannerToProduct.removeEventListener('change', this._handleLinkBannerToProductChange.bind(this));
    // this.$.linkBannerToUrl.removeEventListener('iron-change', this._handleLinkBannerToUrlChange.bind(this));
    }

    async getBanners() {
        let banners = await MySiteRestService.getMarketBanners(this.mySite.currentMarket, this.mySite.currentLanguage);
        banners = [this.noBannerOption].concat(banners);
    
        this.set('banners', banners);
        this.setSelectedBanner();
    }

    async _subscribeToMySiteDataChanges() {
        if(this.mySite.currentForm !== BannerContent.is) return;
        await this.getBanners();
        this.set('data', this.mySite.mySiteData);
        this.set('subdomain', Object.keys(this.data.storefront)[0]);
        let banner = this.data.storefront[this.subdomain][this.mySite.currentMarket].lang[this.mySite.currentLanguage].banner || this.noBannerOption;

        if(banner.ctaLink) {
            let urlParts = banner.ctaLink.split(/\/?content\/nuskin\/[a-z][a-z]_[A-Z][A-Z]/g);
            if(urlParts.length) {
                let ln_ctry = `${this.mySite.currentLanguage}_${this.mySite.currentMarket}`;
                let urlPart = urlParts[urlParts.length-1];
                banner.ctaLink = `/content/nuskin/${ln_ctry}${urlPart}`;
            }
        }

        this.setSelectedBanner(banner);
    } 

    setSelectedBanner(banner) {
        banner = banner || this.selectedBanner;
        if(this.banners && banner) {
            let index = this.banners.findIndex(item => item.imageUrls.desktop === banner.imageUrls.desktop);
            // handle case where image url was changed
            index = index < 0 ? 0 : index;
            this.set('selectedIndex', index);
        } else  
            this.set('selectedIndex', 0);
        this.selectedBanner === this.banners[this.selectedIndex];
    }

    _handleBannerSelect(e) {
        let banner = JSON.parse(e.detail.selectedItem.value);
        let currentBanner = this.data.storefront[this.subdomain][this.mySite.currentMarket].lang[this.mySite.currentLanguage].banner || this.noBannerOption;
        if(banner && currentBanner && currentBanner.titleText !== banner.titleText) {
            this.parentElement.formTouched();
            this.parentElement.setFormValidity(true);
        }

        this.set('selectedBanner', banner);

        if(this.selectedBanner.titleText === this.content.bannerFormNoBanner)
            this.selectedBanner = null;
    
        this.parentNode.updateAndNotify(this.selectedBanner, true, true, 'banner');
    }

    save() {
        let that = this;
        return function() {
            // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.SECTION_DATA_UPDATE, {
                    mySite: {
                        section: BannerContent.is,
                        changed: that.selectedBanner
                    }
                });
            } catch(err) {console.log(err)}
      
            return MySiteRestService.saveBanner(that.selectedBanner);
        }
    }

    getShortenedText(title) {
        if(!title) return this.content.bannerFormNoBanner;
        return title.length > 25 ? title.slice(0, 25)+'...' : title;
    }

    // PHASE 2 stuff

    // overwriteParepRadioButtonStyles() {
    //   let linkBannerToProduct = this.$.linkBannerToProduct;
    //   linkBannerToProduct.$.offRadio.style.borderWidth = '1px';
    //   linkBannerToProduct.shadowRoot.styleSheets[0].addRule(':host([checked]) #onRadio', 'transform: scale(0.68)');

    //   let linkBannerToUrl = this.$.linkBannerToUrl;
    //   linkBannerToUrl.$.offRadio.style.borderWidth = '1px';
    //   linkBannerToUrl.shadowRoot.styleSheets[0].addRule(':host([checked]) #onRadio', 'transform: scale(0.68)');
    // }

    // _handleLinkBannerToProductChange(e) {}
  
    // _handleLinkBannerToUrlChange(e) {}

    // _handleBannerLinkedProduct(newVal) {
    //   if(newVal) {
    //     this.$.productSearch.className += ' has-product';
    //     this.$.selectedProductWrapper.className += ' has-product';
    //   } else {
    //     this.$.productSearch.className = this.$.linkBannerToProduct.className.split(/\s?has-product/).join('');
    //     this.$.selectedProductWrapper.className = this.$.selectedProduct.className.split(/\s?has-product/).join('');
    //   }
    // }

    // _handleLinkedProductRemove(e) {
    //   this.set('bannerLinkedProduct', null);
    // } 

    // _handleLinkBannerToProductClick(e) {
    //   this.$.linkBannerToProduct.checked = true;
    //   this.$.linkBannerToUrl.checked = false;
    // }

    // _handleLinkBannerToUrlClick(e) {
    //   this.$.linkBannerToUrl.checked = true;
    //   this.$.linkBannerToProduct.checked = false;
    // }

    // _handlePredictiveSearch(e) {
    //   let res = e.detail;
    //   this.searchedProducts = res && res.length ? res : [{}]; // empty object is added to indicate 'No Results'
    // }

    // isEmptyIndicator(item) {
    //   return Object.keys(item).length === 0;
    // }

    // _onSlottedSelect(e) {
    //   let item = JSON.parse(e.currentTarget.dataset.item);
    //   this.bannerLinkedProduct = item // TODO: build url to product
    //   this.parentElement.formTouched();
    // }

}

window.customElements.define(BannerContent.is, BannerContent);
